import React, { useMemo, useState } from 'react'
import st from './AutoBots.module.scss'
import { BlockHeader } from 'components/UI/BlockHeader/BlockHeader'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import CheckboxToggle from 'components/ContentBox/Global/CheckboxToggle/CheckboxToggle'
import { AutoBotEditModal } from './AutoBotEditModal'
import { useAutoBotsSettings } from './useAutoBotsSettings'

const truncate = (text, max = 80) =>
  text.length > max ? `${text.slice(0, max)}…` : text

export const AutoBots = () => {
  const { bots, isLoading, toggleBot, saveBot } = useAutoBotsSettings()
  const [editingBot, setEditingBot] = useState(null)

  const activeCount = useMemo(
    () => bots.filter((b) => b.is_active).length,
    [bots],
  )

  if (isLoading) {
    return (
      <div className={st.container}>
        <BlockHeader title='Автоботы' />
        <Loader />
      </div>
    )
  }

  return (
    <div className={st.container}>
      <BlockHeader title='Автоботы'></BlockHeader>

      <div className={st.tableWrap}>
        <table className={st.table}>
          <thead className={st.thead}>
            <tr>
              <th className={st.colName}>Название</th>
              <th className={st.colTrigger}>Триггер</th>
              {/*<th className={st.colStatus}>Статус</th>*/}
              <th className={st.colText}>Текст</th>
            </tr>
          </thead>
          <tbody>
            {bots.map((bot) => (
              <tr
                key={bot.key}
                className={st.row}
                onClick={() => setEditingBot(bot)}
              >
                <td className={st.name}>{bot.name}</td>
                <td className={st.trigger}>{bot.trigger}</td>
                {/*<td className={st.status} onClick={(e) => e.stopPropagation()}>*/}
                {/*  <CheckboxToggle*/}
                {/*    checked={bot.is_active}*/}
                {/*    onChange={(next) => toggleBot(bot, next)}*/}
                {/*  />*/}
                {/*</td>*/}
                <td className={st.text}>
                  {bot.text ? (
                    <span title={bot.text}>{truncate(bot.text)}</span>
                  ) : (
                    <span className={st.empty}>Текст не задан</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editingBot && (
        <AutoBotEditModal
          bot={editingBot}
          onClose={() => setEditingBot(null)}
          onSave={async (updated) => {
            await saveBot(updated)
          }}
        />
      )}
    </div>
  )
}
